import { EmailAddressStep } from "./steps/EmailAddressStep";
import { PasswordStep } from "./steps/PasswordStep";
import { LoginFormSteps, LoginStepProps } from "./steps/StepModel";
import { TwoFactorAuthStep } from "./steps/TwoFactorAuthStep";

export const LoginStep: React.FC<LoginStepProps> = (props: LoginStepProps) => {
  switch (props.currentStep) {
    case LoginFormSteps.EmailAddress:
      return <EmailAddressStep {...props} />;
    case LoginFormSteps.Password:
      return <PasswordStep {...props} />;
    case LoginFormSteps.TwoFactorAuth:
      return <TwoFactorAuthStep {...props} />;
    default:
      return <></>;
  }
};
